import { configureFonts, DefaultTheme } from "react-native-paper";
import { fontConfig } from "./fonts";

declare global {
  namespace ReactNativePaper {
    interface ThemeColors {
      backgroundForm: string;
      select: string;
      divider: string;
      colorRadio: string;
      deselect: string;
      whiteText: string;
      blackText: string;
      success: string;
      warning: string;
    }

    interface ThemeFonts {
      bold: ThemeFont;
      semibold: ThemeFont;
      card: ThemeFont;
    }
  }
}

const LightTheme: any = {
  ...DefaultTheme,
  dark: false,
  roundness: 24,
  colors: {
    primary: "#FFC708",
    accent: "#0772BA",
    background: "rgb(249,249,246)",
    surface: "#FFF",
    error: "#B00020",
    success: "#0fa70f",
    text: "#000",
    onSurface: "#000000",
    disabled: "rgba(0,0,0,0.26)",
    placeholder: "rgba(0,0,0,0.54)",
    backdrop: "rgba(0,0,0,.75)",
    notification: "rgba(242, 239, 233, 1)",
    backgroundForm: "#F2EFE9",
    select: "#F5F8FA",
    divider: "#CFDCE5",
    colorRadio: "#D81221",
    deselect: "rgba(224, 223, 223, 1)",
    whiteText: "#FFF",
    blackText: "#000",
    warning: "#e6983a",
  },
  fonts: configureFonts(fontConfig),
  animation: {
    scale: 1.0,
  },
};

export default LightTheme;
